import { CustomerSearch } from "~/shared/components/customer-search/customer-search.tsx";
import type { Customer } from "~/shared/types/quote-details-types";

import * as styles from "./index.module.css";

type RoutingGuideHeaderProps = {
	selectedCustomer: Customer | undefined;
	onCustomerChange: (customer: Customer | null) => void;
};

export const RoutingGuideHeader = ({
	selectedCustomer,
	onCustomerChange,
}: RoutingGuideHeaderProps) => {
	return (
		<div className={styles.routingGuideHeader}>
			<CustomerSearch
				onCustomerChange={onCustomerChange}
				selectedCustomer={selectedCustomer}
				wrapperStyle={{ width: "300px" }}
			/>
		</div>
	);
};
